/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */
// baki

import React, { useState, useEffect, useContext } from 'react';
import Alert from 'react-s-alert';
import { Table, Progress, Pagination, PaginationItem, PaginationLink, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import moment from 'moment';
import { Link } from 'react-router-dom';

// context imports
import { ThemeContext } from '../../../contexts/ThemeContext';
import { AuthContext } from '../../../contexts/AuthContext';

// service imports
import ProviderService from '../../../services/ProviderService';
import GeneralService from '../../../services/GeneralService';
import DemoService from '../../../services/DemoService';

// local imports
import UserNotApproved from './UserNotApproved';
import Message from '../../general/Message';
import ErrorBoundary from '../../general/ErrorBoundary';
import ProviderNavbar from './ProviderNavbar';
import Loading from '../../../assets/UW_Horizontal_Logo_Full.png';
import { providerSubscriptionPlans, providerSubscriptions as dbProviderSubscriptions } from '../demoData';

const ProviderSubscription = props => {

    // variables
    let timeout = 0;

    // contexts
    const { theme, fontWeight, colors } = useContext(ThemeContext);
    const { user, setUser, selectedTimeZone, userApprovalStatus } = useContext(AuthContext);

    // states
    const [availablePlans, setAvailablePlans] = useState([]);
    const [selectedSubscriptionPlan, setSelectedSubscriptionPlan] = useState({});
    const [currentSubscription, setCurrentSubscription] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [planCancelled, setPlanCancelled] = useState({
        status: false,
        message: {
            msgBody: '',
            msgError: true
        }
    });
    const [providerSubscriptions, setProviderSubscriptions] = useState([]);
    const [pagination, setPagination] = useState({ limit: 10, page: 1 });

    // useEffects
    useEffect(() => {
        getActiveProviderSubsription();
        getProviderSubscriptions();
    }, []);

    // utility functions
    const getProviderSubscriptions = async () => {
        setIsLoading(true);
        // try {
        // ProviderService.getProviderSubcriptions()
        // .then(data => {
        setProviderSubscriptions(dbProviderSubscriptions);
        // console.log('Provider Subscriptions', data.providerSubscriptions)
        setIsLoading(false);
        //         })
        // } catch (err) {
        //     setIsLoading(false);
        //     console.log(err);
        // }
    }

    const getActiveProviderSubsription = async () => {
        setIsLoading(true);
        try {
            // ProviderService.getProviderSubscriptionPlans()
            //     .then(subscriptionPlans => {
            //         try {
            // console.log("subscriptionPlans", subscriptionPlans);
            setAvailablePlans(providerSubscriptionPlans);
            // ProviderService.getActiveProviderSubsription()
            // .then(subscription => {
            // try {
            // console.log("subscription", subscription);
            // if (subscription.providerSubscription) {
            if (dbProviderSubscriptions[0].isCancelled) {
                setPlanCancelled({
                    status: true,
                    message: {
                        msgBody: `Your subscription has been cancelled. No more charge attempts will be made on your card after ${moment(dbProviderSubscriptions[0].subscriptionCycle[dbProviderSubscriptions[0].subscriptionCycle.length - 1].endDate).format("MMM DD, dddd")}.`,
                        msgError: true
                    }
                })
            }
            let latestCycleIndex = 0;
            let currentCycleTotalDays = 0;
            let currentCycleDaysGone = 0;
            if (dbProviderSubscriptions[0].providerSubscriptionPlan.name !== "Free" && dbProviderSubscriptions[0].razorpaySubscriptionId) {
                latestCycleIndex = dbProviderSubscriptions[0].subscriptionCycle.length - 1;
                currentCycleTotalDays = moment(dbProviderSubscriptions[0].subscriptionCycle[latestCycleIndex].endDate).diff(moment(dbProviderSubscriptions[0].subscriptionCycle[latestCycleIndex].startDate), 'days') + 1;
                currentCycleDaysGone = moment().diff(moment(dbProviderSubscriptions[0].subscriptionCycle[latestCycleIndex].startDate), 'days') + 1;
            }
            setCurrentSubscription({ ...dbProviderSubscriptions[0], currentCycleDaysGone, currentCycleTotalDays });
            // }
            setIsLoading(false);
            //     } catch (err) {
            //         setIsLoading(false);
            //         console.log("err", err);
            //         Alert.error("Some error occured, please try again later or report support team.", {
            //             position: 'top-right',
            //             effect: 'slide'
            //         });
            //         // GeneralService.logError('at BookSession useEffect2_1', err.stack);
            //     }
            // });
            //     } catch (err) {
            //         setIsLoading(false);
            //         console.log(err);
            //         Alert.error("Some error occured, please try again later or report support team.", {
            //             position: 'top-right',
            //             effect: 'slide'
            //         });
            //         // GeneralService.logError('at BookSession useEffect2_1', err.stack);
            //     }
            // });
        } catch (err) {
            setIsLoading(false);
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at Client BookSession useEffect2_1', 'Error in try catch block', err.stack);
        }
    }

    // handle functions
    const handlePlanSelect = e => {
        // console.log(selectedSubscriptionPlan._id)
        if (selectedSubscriptionPlan._id) {
            try {
                props.history.push({
                    pathname: "/demo/counsellor/makesubscriptionpayment",
                    state: {
                        selectedSubscriptionPlan: selectedSubscriptionPlan
                    }
                });
            } catch (err) {
                console.log(err);
            }
        }
    }

    const handleCancelPlan = e => {
        props.history.push({
            pathname: "/demo/counsellor/cancelsubscription",
            state: {
                currentSubscription: currentSubscription
            }
        });
    }

    const handleSearch = e => {
        try {
            let value = e.target.value;
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(() => {
                setPagination({ ...pagination, searchVal: value });
            }, 500);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin Clients handleSerach', 'Error in try catch block', err.stack);
        }
    }

    const handlePagination = (e, index) => {
        e.preventDefault();
        try {
            // if(e.target.id === "limit"){
            //     const value = e.target.value;
            //     setTimeout(() => {
            //         setPagination({...pagination, limit: value});
            //     }, 500);
            // }
            // else
            setPagination({ ...pagination, page: index });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin Clients handlePagination', 'Error in try catch block', err.stack);
        }
    }

    // function's return
    return (
        <div>
            <ProviderNavbar history={props.history} />
            {
                isLoading ?
                    <img className="mx-auto d-block" height="auto" width="40%" src={Loading} alt="Loading..." />
                    :
                    userApprovalStatus || true ?
                        <div className="p-2">
                            {/* 
                            {
                                providerSubscriptions
                                ? */}
                            <div>
                                {
                                    currentSubscription && currentSubscription.isActive ?
                                        <div>
                                            {/* Page Heading */}
                                            <div>
                                                <h1 style={theme.headingBold}>Subscription</h1>
                                                <hr style={{ borderWidth: "2px" }} />
                                            </div>
                                            {planCancelled.status ? <Message message={planCancelled.message} /> : null}
                                            <div className="d-flex">
                                                <div style={{ fontWeight: "500" }}>Current Subscription Plan Details</div>
                                                {
                                                    currentSubscription.isCancelled ? null
                                                        :
                                                        [<div key="1" className="ml-auto" style={{ color: colors.primary, cursor: "pointer" }} onClick={() => props.history.push('/demo/counsellor/updateSubscription')}>Change Plan<i className="fas fa-external-link-alt ml-1"></i></div>,
                                                        <div key="2" className="ml-3" style={{ color: colors.danger, cursor: "pointer" }} onClick={() => handleCancelPlan()}>Cancel Plan</div>]
                                                }
                                            </div>
                                            <hr />
                                            {/* <ErrorBoundary errorAt="At Client Subsciptions SelectedProvider">
                                                    <SelectedProvider
                                                        selectedProvider={selectedProvider}
                                                    />
                                                </ErrorBoundary> */}
                                            <Table borderless>
                                                <tbody>
                                                    <tr>
                                                        <td style={{ width: '30%' }}>
                                                            <span style={{ fontWeight: fontWeight.medium }}>Subscription Plan</span>
                                                        </td>
                                                        <td>
                                                            <span>{currentSubscription.name}</span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <span style={{ fontWeight: fontWeight.medium }}>Sessions</span>
                                                        </td>
                                                        <td className="d-flex">
                                                            <Progress className="successProgress my-auto mr-2" value={(100 * currentSubscription.subscriptionCycle[currentSubscription.subscriptionCycle.length - 1].serviceDetails.sessionBookingCount) / currentSubscription.subscriptionCycle[currentSubscription.subscriptionCycle.length - 1].serviceDetails.sessionBookingLimit} /><span>{`${currentSubscription.subscriptionCycle[currentSubscription.subscriptionCycle.length - 1].serviceDetails.sessionBookingCount}/${currentSubscription.subscriptionCycle[currentSubscription.subscriptionCycle.length - 1].serviceDetails.sessionBookingLimit}`}</span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <span style={{ fontWeight: fontWeight.medium }}>Clients</span>
                                                        </td>
                                                        <td className="d-flex">
                                                            <Progress className="successProgress my-auto mr-2" value={(100 * currentSubscription.subscriptionCycle[currentSubscription.subscriptionCycle.length - 1].serviceDetails.clientCount) / currentSubscription.subscriptionCycle[currentSubscription.subscriptionCycle.length - 1].serviceDetails.clientLimit} /><span>{`${currentSubscription.subscriptionCycle[currentSubscription.subscriptionCycle.length - 1].serviceDetails.clientCount}/${currentSubscription.subscriptionCycle[currentSubscription.subscriptionCycle.length - 1].serviceDetails.clientLimit}`}</span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <span style={{ fontWeight: fontWeight.medium }}>Call Sessions</span>
                                                        </td>
                                                        <td className="d-flex">
                                                            <span><i className={`fas fa-${currentSubscription.subscriptionCycle[currentSubscription.subscriptionCycle.length - 1].serviceDetails.modeOfServices.call ? 'check' : 'times danger_text_color'}`}></i></span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <span style={{ fontWeight: fontWeight.medium }}>Video Sessions</span>
                                                        </td>
                                                        <td className="d-flex">
                                                            <span><i className={`fas fa-${currentSubscription.subscriptionCycle[currentSubscription.subscriptionCycle.length - 1].serviceDetails.modeOfServices.video ? 'check' : 'times danger_text_color'}`}></i></span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <span style={{ fontWeight: fontWeight.medium }}>In Person Sessions</span>
                                                        </td>
                                                        <td className="d-flex">
                                                            <span><i className={`fas fa-${currentSubscription.subscriptionCycle[currentSubscription.subscriptionCycle.length - 1].serviceDetails.modeOfServices.inPerson ? 'check' : 'times danger_text_color'}`}></i></span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <span style={{ fontWeight: fontWeight.medium }}>Messaging</span>
                                                        </td>
                                                        <td className="d-flex">
                                                            <span><i className={`fas fa-${currentSubscription.subscriptionCycle[currentSubscription.subscriptionCycle.length - 1].serviceDetails.modeOfServices.chat ? 'check' : 'times danger_text_color'}`}></i></span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <span style={{ fontWeight: fontWeight.medium }}>Create Subscription Plans</span>
                                                        </td>
                                                        <td className="d-flex">
                                                            <span><i className={`fas fa-${currentSubscription.subscriptionCycle[currentSubscription.subscriptionCycle.length - 1].serviceDetails.createClientSubscriptionPlans ? 'check' : 'times danger_text_color'}`}></i></span>
                                                        </td>
                                                    </tr>
                                                    {
                                                        currentSubscription.providerSubscriptionPlan.name === "Free" && currentSubscription.razorpaySubscriptionId === "" ?
                                                            null : [
                                                                <tr key="1">
                                                                    <td>
                                                                        <span style={{ fontWeight: fontWeight.medium }}>Start Date</span>
                                                                    </td>
                                                                    <td>
                                                                        <span>{moment().subtract(3, 'days').format("MMM DD dddd, YYYY")}</span>
                                                                    </td>
                                                                </tr>,
                                                                <tr key="2">
                                                                    <td>
                                                                        <span style={{ fontWeight: fontWeight.medium }}>Next Payment Date</span>
                                                                    </td>
                                                                    <td>
                                                                        <span>{currentSubscription.isCancelled ? "-" : moment().add(27, 'days').format("MMM DD dddd, YYYY")}</span>
                                                                    </td>
                                                                </tr>,
                                                                <tr key="3">
                                                                    <td>
                                                                        <span style={{ fontWeight: fontWeight.medium }}>Days Passed</span>
                                                                    </td>
                                                                    <td className="d-flex">
                                                                        <Progress className="successProgress my-auto mr-2" value={(100 * 3) / 30} /><span>{`${3}/${30}`}</span>
                                                                    </td>
                                                                </tr>
                                                            ]
                                                    }
                                                </tbody>
                                            </Table>


                                            <div className='mt-5'>
                                                <div className="d-flex">
                                                    <div style={{ fontWeight: "500" }}>Subscription History</div>
                                                </div>
                                                <hr />

                                                <div className="card mb-4">
                                                    <div className="card-header">
                                                        History
                                                    </div>
                                                    <div className="card-body py-0">
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered mb-0" id="dataTable" width="100%" cellSpacing="0">
                                                                <thead>
                                                                    <tr>
                                                                        <td colSpan="6" className="border-0 px-0">
                                                                            <div className="d-flex">
                                                                                <div className="ml-auto">
                                                                                    Search<input type="text" id="searchInput" className="ml-2" style={{ marginRight: "-20px", paddingRight: "20px" }} onChange={handleSearch}></input>
                                                                                    <span style={{ cursor: "pointer", marginRight: "7px", alignSelf: "center", zIndex: 100 }} onClick={() => { document.getElementById("searchInput").value = ""; setPagination({ ...pagination, searchVal: "" }); }}><i className="fa fa-times"></i></span>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>Unique id</th>
                                                                        <th>Plan name</th>
                                                                        <th>Status</th>
                                                                        <th>Subscription Cycle(s)</th>
                                                                        <th>Details</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {

                                                                        providerSubscriptions.map((item, index) => (
                                                                            <ErrorBoundary errorAt={`At Provider Subscription History Table${index}`}>
                                                                                <tr key={index}>
                                                                                    <td>{item._id}</td>
                                                                                    <td>{item.providerSubscriptionPlan.name}</td>
                                                                                    <td>{item.isActive ? 'Active' : 'Inactive'}</td>
                                                                                    <td>{item.subscriptionCycle.length}</td>
                                                                                    <td align="center">
                                                                                        <Link to={{
                                                                                            pathname: '/demo/counsellor/subscription/details',
                                                                                            state: providerSubscriptions[index]
                                                                                        }}>
                                                                                            View Details
                                                                                        </Link>
                                                                                    </td>
                                                                                </tr>
                                                                            </ErrorBoundary>
                                                                        ))
                                                                    }
                                                                </tbody>
                                                                <tfoot>
                                                                    <tr>
                                                                        <td colSpan="6" className="border-0 pb-0 px-0">
                                                                            <div className="d-flex">
                                                                                {/* <div className="d-flex p-2">
                                                                                        <span>Showing {pagination.totalResults==0 ? 0 : 1 } to</span>
                                                                                        <Input style={{width:'47px', height: '30px', padding: '14px 5px', margin: '0 5px'}} id="limit" minLength="1" maxLength="4" name="limit" value={pagination.limit>pagination.totalResults ? pagination.totalResults : pagination.limit} onChange={e => handlePagination(e,null)} ></Input>
                                                                                        <span>of {pagination.totalResults} entries</span>
                                                                                    </div> */}
                                                                                <ErrorBoundary errorAt="At Admin Clients Pagination">
                                                                                    <div className="p-2">Showing {pagination.totalResults == 0 ? 0 : (1 + (10 * (pagination.page - 1)))} to {(pagination.limit + (10 * (pagination.page - 1))) > pagination.totalResults ? pagination.totalResults : (pagination.limit + (10 * (pagination.page - 1)))} of {pagination.totalResults} entries</div>
                                                                                    <Pagination aria-label="Page navigation example" className="ml-auto">
                                                                                        <PaginationItem disabled={pagination.page == 1}>
                                                                                            <PaginationLink
                                                                                                onClick={e => handlePagination(e, pagination.page - 1)}
                                                                                                previous
                                                                                                href="#" />
                                                                                        </PaginationItem>
                                                                                        {[...Array(pagination.totalPages)].map((page, i) =>
                                                                                            <PaginationItem active={i + 1 === pagination.page} key={i}>
                                                                                                <PaginationLink onClick={e => handlePagination(e, i + 1)} href="#">
                                                                                                    {i + 1}
                                                                                                </PaginationLink>
                                                                                            </PaginationItem>
                                                                                        )}
                                                                                        <PaginationItem disabled={pagination.page == pagination.totalPages}>
                                                                                            <PaginationLink
                                                                                                onClick={e => handlePagination(e, pagination.page + 1)}
                                                                                                next
                                                                                                href="#" />
                                                                                        </PaginationItem>
                                                                                    </Pagination>
                                                                                </ErrorBoundary>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tfoot>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="text-center">
                                            <div>
                                                <h1 style={{ fontFamily: "Montserrat, sans-serif", fontSize: "1.8rem", fontWeight: "500", color: "#384E73" }}>Subscriptions - Plans &amp; Pricings</h1>
                                                <h2 style={{ fontFamily: "Montserrat, sans-serif", fontSize: "1.2rem", fontWeight: "500" }}>Select subscription with your Counsellor that best suits your needs.<br />You can update / cancel your subscription anytime.</h2>
                                            </div>
                                            {
                                                availablePlans.map((item, index) => (
                                                    <div key={index} className="d-inline-block col-8 col-sm-8 col-md-3 text-center px-2 py-3 m-3" style={selectedSubscriptionPlan._id === item._id ? theme.selectedSlotCard : theme.slotCard} onClick={() => setSelectedSubscriptionPlan(item)}>
                                                        <h2 style={Object.assign({ color: "#384E73" }, theme.subHeadingSemibold)}>{item.name}</h2>
                                                        <p>{`₹${item.amount / 100} / Month`}</p>
                                                        <div>
                                                            <p><i className='fas fa-check'></i> Upto {item.serviceDetails.sessionBookingLimit} Session Bookings</p>
                                                            <p><i className='fas fa-check'></i> Upto {item.serviceDetails.clientLimit} Clients</p>
                                                            <p><i className={`fas fa-${item.serviceDetails.modeOfServices.call ? 'check' : 'times danger_text_color'}`}></i> Call</p>
                                                            <p><i className={`fas fa-${item.serviceDetails.modeOfServices.chat ? 'check' : 'times danger_text_color'}`}></i> Chat</p>
                                                            <p><i className={`fas fa-${item.serviceDetails.modeOfServices.video ? 'check' : 'times danger_text_color'}`}></i> Video</p>
                                                            <p><i className={`fas fa-${item.serviceDetails.modeOfServices.inPerson ? 'check' : 'times danger_text_color'}`}></i> In Person</p>
                                                            <p><i className={`fas fa-${item.serviceDetails.createClientSubscriptionPlans ? 'check' : 'times danger_text_color'}`}></i> Create Client Subscription Plans</p>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                            <div>
                                                <button className="btn mx-auto mt-4" id="paymentBtn" type="button" style={theme.button} onClick={() => handlePlanSelect()}>
                                                    Continue Payment
                                                </button>
                                            </div>
                                        </div>
                                }
                            </div>
                            {/* : null
                            } */}

                            {/* cancel sub
        survey for cancel sub
        update sub
        check why cancel */}
                        </div>
                        :
                        <UserNotApproved />
            }

        </div >
    )

}

export default ProviderSubscription;